import { render, staticRenderFns } from "./ModuleStakingCenter.vue?vue&type=template&id=768d3bdc&scoped=true"
import script from "./ModuleStakingCenter.vue?vue&type=script&lang=js"
export * from "./ModuleStakingCenter.vue?vue&type=script&lang=js"
import style0 from "./ModuleStakingCenter.vue?vue&type=style&index=0&id=768d3bdc&prod&lang=scss&scoped=true"
import style1 from "./ModuleStakingCenter.vue?vue&type=style&index=1&id=768d3bdc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768d3bdc",
  null
  
)

export default component.exports